module.exports = __webpack_public_path__ + "img/ИФ-1(А)-045-m.c2a53f13.png";